var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "enterprise-wechat-approval-index details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: { "left-style": { flex: "none", "max-width": "190px" } }
        },
        [
          _c("template", { slot: "left" }, [
            _c("div", { staticClass: "app-main-content" }, [
              _c("div", { staticClass: "grid-view" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      flex: "1"
                    }
                  },
                  [
                    _c("el-tree", {
                      staticClass: "custom-category-list section",
                      staticStyle: { width: "180px" },
                      attrs: {
                        "highlight-current": "",
                        "node-key": "id",
                        data: _vm.leftData,
                        "current-node-key": _vm.currentNodeKey
                      },
                      on: { "node-click": _vm.handleSelect }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "app-main-content" }, [
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _vm.activeMenu === "1"
                    ? _c(
                        "el-tabs",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "card" },
                          on: { "tab-click": _vm.handleClick },
                          model: {
                            value: _vm.lookActiveTab,
                            callback: function($$v) {
                              _vm.lookActiveTab = $$v
                            },
                            expression: "lookActiveTab"
                          }
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookAll" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_All")) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.lookActiveTab === "lookAll"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookAll",
                                    attrs: {
                                      status: 0,
                                      type: "look",
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookProcessing" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Processing")
                                      ) +
                                      " "
                                  ),
                                  _vm.initiated.processingCount > 0
                                    ? _c("el-badge", {
                                        attrs: {
                                          value: _vm.initiated.processingCount
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.lookActiveTab === "lookProcessing"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookProcessing",
                                    attrs: {
                                      status: 1,
                                      type: "look",
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookApproved" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Approved")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.lookActiveTab === "lookApproved"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookApproved",
                                    attrs: {
                                      status: 2,
                                      type: "look",
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookRejected" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Rejected")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.lookActiveTab === "lookRejected"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookRejected",
                                    attrs: {
                                      status: 3,
                                      type: "look",
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "lookCancelled" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Cancelled")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.lookActiveTab === "lookCancelled"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "lookCancelled",
                                    attrs: {
                                      status: 4,
                                      type: "look",
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-tabs",
                        {
                          attrs: { type: "card" },
                          on: { "tab-click": _vm.handleClick },
                          model: {
                            value: _vm.approveActiveTab,
                            callback: function($$v) {
                              _vm.approveActiveTab = $$v
                            },
                            expression: "approveActiveTab"
                          }
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approveAll" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_All")) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.approveActiveTab === "approveAll"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approveAll",
                                    attrs: {
                                      type: "approve",
                                      status: 0,
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approvePending" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Pending")) +
                                      " "
                                  ),
                                  _vm.approve.processingCount > 0
                                    ? _c("el-badge", {
                                        attrs: {
                                          value: _vm.approve.processingCount
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.approveActiveTab === "approvePending"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approvePending",
                                    attrs: {
                                      type: "approve",
                                      status: 1,
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approveApproved" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Approved")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.approveActiveTab === "approveApproved"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approveApproved",
                                    attrs: {
                                      type: "approve",
                                      status: 2,
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approveRejected" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Rejected")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.approveActiveTab === "approveRejected"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approveRejected",
                                    attrs: {
                                      type: "approve",
                                      status: 3,
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { name: "approveCancelled" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_Cancelled")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _vm.approveActiveTab === "approveCancelled"
                                ? _c("enterprise-wechat-approval-detail", {
                                    key: _vm.detailRefreshId,
                                    ref: "approveCancelled",
                                    attrs: {
                                      type: "approve",
                                      status: 4,
                                      "document-config-id":
                                        _vm.documentConfigId,
                                      "template-columns":
                                        _vm.currentTemplateColumns
                                    },
                                    on: { reloadCount: _vm.reloadCount }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }